import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import PushEnableButton from "@/components/PushEnableButton";
import { isPushSupported, pushStatus } from "@/lib/push";
import { BellRing, Send } from "lucide-react";

export function PushBanner() {
  const [active, setActive] = useState(null);
  useEffect(() => {
    if (!isPushSupported()) { setActive(false); return; }
    pushStatus().then((s) => setActive(!!(s.server && s.local))).catch(() => setActive(false));
  }, []);
  const test = async () => {
    try {
      const { data } = await api.post("/push/test", { title: "RDM ClassRoom", body: "Notifica di prova: funziona!", url: "/portale/bacheca" });
      data.delivered ? toast.success("Notifica di prova inviata: dovrebbe arrivare tra pochi secondi") : toast.error("Nessun dispositivo registrato: premi \"Attiva notifiche\"");
    } catch { toast.error("Invio non riuscito"); }
  };
  if (active === null) return null;
  if (active) {
    return (
      <div className="mb-5 flex items-center justify-between gap-3 text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-xl px-4 py-2" data-testid="push-banner-active">
        <span className="inline-flex items-center gap-1.5"><BellRing size={14}/> Notifiche attive su questo dispositivo</span>
        <Button size="sm" variant="ghost" className="h-7 text-emerald-800" onClick={test} data-testid="push-test-btn"><Send size={12} className="mr-1"/> Prova</Button>
      </div>
    );
  }
  return (
    <div className="mb-5 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 flex flex-wrap items-center gap-3" data-testid="push-banner">
      <BellRing size={18} className="text-amber-700"/>
      <div className="flex-1 min-w-[200px] text-sm text-amber-900">
        <b>Attiva le notifiche</b> per ricevere subito gli avvisi importanti sul telefono.
      </div>
      <div className="[&_button]:!bg-[#1C352D] [&_button]:!text-white [&_button]:!border-0"><PushEnableButton/></div>
    </div>
  );
}
